var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChatGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icChatGray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.41329482,19.5 C4.36418422,19.5 4.31449096,19.4879361 4.26970875,19.463891 C4.17148755,19.4115041 4.1103074,19.3092918 4.1103074,19.199147 L4.1103074,14.9131694 C1.45750268,13.543838 0,11.1463512 0,8.14244854 C0,3.50025636 4.29875892,0 10,0 C15.7012411,0 20,3.50025636 20,8.14244854 C20,12.7839797 15.7012411,16.284236 10,16.284236 C9.81271382,16.284236 9.62909012,16.2740726 9.44488376,16.264405 L9.43273097,16.2638266 L4.5799379,19.4500093 C4.52966197,19.4831436 4.4714784,19.5 4.41329482,19.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Version3-Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interested-in-this-event-frm-user-hover",
    transform: "translate(-857.000000, -384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends",
    transform: "translate(470.000000, 143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(387.812308, 241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icChatGray"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#8B8B8B",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00462963,9.26851852 C5.44620838,9.26851852 4.99351852,8.81582865 4.99351852,8.25740741 C4.99351852,7.69898616 5.44620838,7.2462963 6.00462963,7.2462963 C6.56305088,7.2462963 7.01574074,7.69898616 7.01574074,8.25740741 C7.01574074,8.81582865 6.56305088,9.26851852 6.00462963,9.26851852 Z M10.1409933,9.26851852 C9.58257202,9.26851852 9.12988215,8.81582865 9.12988215,8.25740741 C9.12988215,7.69898616 9.58257202,7.2462963 10.1409933,7.2462963 C10.6994145,7.2462963 11.1521044,7.69898616 11.1521044,8.25740741 C11.1521044,8.81582865 10.6994145,9.26851852 10.1409933,9.26851852 Z M14.2773569,9.26851852 C13.7189357,9.26851852 13.2662458,8.81582865 13.2662458,8.25740741 C13.2662458,7.69898616 13.7189357,7.2462963 14.2773569,7.2462963 C14.8357781,7.2462963 15.288468,7.69898616 15.288468,8.25740741 C15.288468,8.81582865 14.8357781,9.26851852 14.2773569,9.26851852 Z",
    id: "Mask",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChatGray);
export default __webpack_public_path__ + "static/media/icChatGray.2aa75389b8a693e16490c17206d9c52e.svg";
export { ForwardRef as ReactComponent };